import { render, staticRenderFns } from "./EditSpaceParent.vue?vue&type=template&id=1377fb7a&"
import script from "./EditSpaceParent.vue?vue&type=script&lang=js&"
export * from "./EditSpaceParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports